'use client'

import { AnimatedPlaceholder } from '../animated-placeholder'
import { cn } from '@/lib/tailwind'

interface FormContentSectionProps {
  content: string
  onContentChange: (value: string) => void
  onClearError: () => void
  isLoading: boolean
  /** Whether the textarea should collapse to a single line (task with checklist, no notes) */
  textareaIsCollapsed: boolean
}

/**
 * Main content textarea with animated placeholder.
 * Voice input is handled at the form level (bottom toolbar).
 */
export function FormContentSection({
  content,
  onContentChange,
  onClearError,
  isLoading,
  textareaIsCollapsed,
}: FormContentSectionProps) {
  return (
    <div className="relative mt-2">
      {!textareaIsCollapsed && <AnimatedPlaceholder show={!content} />}
      <textarea
        id="content"
        placeholder={textareaIsCollapsed ? 'Add notes...' : undefined}
        value={content}
        onChange={(e) => {
          onContentChange(e.target.value)
          onClearError()
          const textarea = e.target
          textarea.style.height = 'auto'
          const maxHeight = window.innerHeight * 0.35
          textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`
        }}
        onFocus={(e) => {
          const textarea = e.target
          textarea.style.height = 'auto'
          const maxHeight = window.innerHeight * 0.35
          textarea.style.height = `${Math.min(textarea.scrollHeight, maxHeight)}px`
        }}
        className={cn(
          'font-body-serif text-foreground/80 placeholder:text-muted-foreground w-full resize-none bg-transparent text-lg leading-relaxed transition-[height] duration-150 outline-none sm:text-base',
          'disabled:cursor-not-allowed disabled:opacity-50',
          textareaIsCollapsed
            ? 'h-9 min-h-0 pb-2'
            : 'min-h-[120px] sm:min-h-[112px]',
        )}
        style={{ maxHeight: '45vh', overflowY: 'auto' }}
        disabled={isLoading}
      />
    </div>
  )
}
